export var RemontMetricCounterNumber = 56439838;
export var RemontDevMetricCounterNumber = 57288148;
var YandexCounters = [RemontMetricCounterNumber];
if (typeof window !== 'undefined' && (window.location.hostname === 'dev.vtblive.ru' || window.location.hostname === 'localhost')) {
  YandexCounters.push(RemontDevMetricCounterNumber);
}
export { YandexCounters };
export var YandexMethodNames = ['init', 'addFileExtension', 'extLink', 'file', 'getClientID', 'hit', 'notBounce', 'params', 'reachGoal', 'replacePhones', 'setUserID', 'userParams'];